var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.3333C4.39763 17.3333 0.666672 13.6023 0.666672 8.99999C0.666672 4.39761 4.39763 0.666656 9 0.666656C13.6023 0.666656 17.3333 4.39761 17.3333 8.99999C17.3333 13.6023 13.6023 17.3333 9 17.3333ZM9 15.6667C12.6819 15.6667 15.6667 12.6819 15.6667 8.99999C15.6667 5.31809 12.6819 2.33332 9 2.33332C5.3181 2.33332 2.33334 5.31809 2.33334 8.99999C2.33334 12.6819 5.3181 15.6667 9 15.6667ZM7.85159 6.01215L11.9173 8.72266C12.0705 8.82474 12.1119 9.03174 12.0098 9.18491C11.9853 9.22149 11.9539 9.25291 11.9173 9.27732L7.85159 11.9878C7.69842 12.09 7.49142 12.0486 7.38934 11.8954C7.35284 11.8407 7.33334 11.7763 7.33334 11.7105V6.2895C7.33334 6.1054 7.48259 5.95616 7.66667 5.95616C7.7325 5.95616 7.79684 5.97564 7.85159 6.01215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.53d747fda3fb18b01c728f3b0190fa95.svg";
export { ForwardRef as ReactComponent };